import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const QueryStartLabel = styled.div`
  color: ${color("text-dark")};
  font-weight: bold;
  margin-bottom: 0.5rem;
`;
